export default __webpack_public_path__ + "static/bogdan-dogaru-b5e9e9af53c1298ef9dafffe899c4f09.svg";